// @flow

import { Component } from '../../jsti/core';
import Notifications from '../../constants/Notifications';
import EventNames from '../../constants/DataLayer/EventNames';

export default class AbstractSort extends Component {
  #sortHandler: function;

  /**
   * Initialize the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.#sortHandler = this.sort.bind(this);
    this.addEventListener(this.event, this.#sortHandler);
  }

  /**
   * Executes when the form is changed
   */
  sort(): void {
    window.store.url.setOrder(this.value);

    this.dispatch({
      event: EventNames.SORTING_USE,
      data: { name: this.value },
      GA4: true
    });

    this.notify(Notifications.SORT, { by: this.value, group: 'sort' });
  }

  /**
   * Get the value of the event the component should listen to
   */
  get event(): string {
    throw new Error('Abstract getter');
  }

  /**
   * Get the value of the sort component
   */
  get value(): string {
    throw new Error('Abstract getter');
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    this.removeEventListener(this.event, this.#sortHandler);
    super.destroy();
  }
}
